import { Typography } from '@/src/shared/components/Typography';

import styles from './OurPresence.module.scss';
import { CarouselV2, Slide } from '@/src/shared/components/Carousel/CarouselV2';
import { data } from './data';
import Image from '@/src/shared/components/Image';
import { Section } from '@/src/containers/Landings/Section';

export const OurPresence = () => {
  return (
    <Section className={styles.container}>
      <Typography tag="h5" variant="heading" size="h5">
        Our Constant Presence by Your Side
      </Typography>
      <CarouselV2
        classes={{ container: styles.carouselContainer }}
        dragFree={false}
        align="center"
      >
        {data.map((item) => (
          <Slide className={styles.card} key={item.title}>
            <div key={item.id} className={styles.cardContainer}>
              <div className={styles.imageWrapper}>
                <Image src={item.image} alt={item.title} fill priority />
              </div>
              <div className={styles.titleWrapper}>
                <Typography
                  tag="span"
                  variant="text"
                  size="md"
                  fontWeight="medium"
                >
                  {item.title}
                </Typography>
              </div>
            </div>
          </Slide>
        ))}
      </CarouselV2>
    </Section>
  );
};
